module.exports = __webpack_public_path__ + "img/product_pressalit_bathe03.db472178.jpg";